var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 2,
    fill: "#8FCF74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78125 2.5625C5.83757 2.5625 5.0625 3.33757 5.0625 4.28125V11.1562C5.0625 12.0999 5.83757 12.875 6.78125 12.875H11.7812C12.7249 12.875 13.5 12.0999 13.5 11.1562V4.28125C13.5 3.33757 12.7249 2.5625 11.7812 2.5625H6.78125ZM6.78125 3.5H11.7812C12.2182 3.5 12.5625 3.8443 12.5625 4.28125V11.1562C12.5625 11.5932 12.2182 11.9375 11.7812 11.9375H6.78125C6.3443 11.9375 6 11.5932 6 11.1562V4.28125C6 3.8443 6.3443 3.5 6.78125 3.5ZM4.4375 4.125L4.05664 4.37891C3.70883 4.61078 3.5 5.00113 3.5 5.41895V11.4688C3.5 13.1084 4.82906 14.4375 6.46875 14.4375H10.6436C11.0617 14.4375 11.452 14.2287 11.6836 13.8809L11.9375 13.5H6.46875C5.34688 13.5 4.4375 12.5906 4.4375 11.4688V4.125Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatIcon);
export default __webpack_public_path__ + "static/media/DuplicatIcon.70b059c595a993548b8778f8c754da74.svg";
export { ForwardRef as ReactComponent };